import { sxtheme } from 'utils/cssHelpers';

export const locationCardStyle = {
  cursor: 'pointer',
  '.ui.list &:hover': {
    bg: sxtheme(t => t.colors?.deepSea20),
    transition: '0.5s all',
    '& .suffix': {
      display: 'block',
    },
  },
  '.ui.list &.active,&:active': {
    bg: sxtheme(t => t.colors?.seafoam20),
  },
  '& .suffix': {
    display: ['initial', 'none'],
  },
};
